import { Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DashboardService extends BaseService {

  constructor(public http: HttpClient, authService: AuthService) {
    super(authService);
  }

  //last 5 payment trans
  public getPaymentRequestList(custId) {
    custId = this.authService.getRegistredUserDetails().customerId
    return this.http.get(this.baseUrl + '/Dashboard/GetPaymentRequestList/' + custId,
      this.headerWithToken()).pipe(map(res => res));
  }

  //last 5 refunds
  public getLastFiveRefunds(custId) {
    custId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/Dashboard/GetRefundRequestList/' + custId,
      this.headerWithToken()).pipe(map(res => res));
  }


   //payment Recieved
  public getRecievedPayments(customerId: any,
    toDate: any, fromDate: any) {
    customerId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/Dashboard/PaymentRecieved?customerId=' + customerId
      + '&toDate=' + toDate + "&fromDate=" + fromDate,
      this.headerWithToken()).pipe(map(res => res));
  }

  //pending remit
  public getPendingRemittedPayments(customerId: any,
    fromDate: any, toDate: any,) {
    customerId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/Dashboard/PendingRemittence?customerId=' + customerId
      + "&fromDate=" + fromDate + '&toDate=' + toDate,
      this.headerWithToken()).pipe(map(res => res));
  }

   //remitted payments
  public getRemittedPayments(customerId: any,
    toDate: any, fromDate: any) {
    customerId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/Dashboard/RemittedPayment?customerId=' + customerId
      + '&toDate=' + toDate + "&fromDate=" + fromDate,
      this.headerWithToken()).pipe(map(res => res));
  }

  //pending payments
  public getPendingPayments(customerId: any,
    toDate: any, fromDate: any) {
    customerId = this.authService.getRegistredUserDetails().customerId;
    return this.http.get(this.baseUrl + '/Dashboard/PendingPayment?customerId=' + customerId
      + '&toDate=' + toDate + "&fromDate=" + fromDate,
      this.headerWithToken()).pipe(map(res => res));
  }




}
